import type { ReactNode } from 'react';

import { openBotLogin, useIsGuest } from '@/auth';
import { ROW, ROW_GO } from '@/components/layout';
import { Notice } from '@/components/Notice';
import { cn } from '@/lib/utils';
import { useT } from '@/str';

export function LoginButton() {
  const t = useT();
  return (
    <button type="button" className={cn(ROW, 'max-w-[380px]')} onClick={openBotLogin}>
      <span>{t.appLoginBtn}</span>
      <span className={ROW_GO} aria-hidden>
        →
      </span>
    </button>
  );
}

export function GuestGate({ children }: { children: ReactNode }) {
  const t = useT();
  if (!useIsGuest()) return children;
  return (
    <Notice sign="→" title={t.guestTitle} body={t.guestBody}>
      <LoginButton />
    </Notice>
  );
}
